/** In-game art uses the screen-print covers only (2:1, light/dark pairs). The
 * older `public/art/play/*` set is retired from the game surfaces. Mafia is
 * phase-bound rather than theme-bound: night is always the navy cover and day
 * always the periwinkle one, so the scene reads as a clock, not a theme. */
const cover = (name: string) => `/art/covers/${name}.webp`;
export const playArt = {
  impostor: { light: cover("impostor-light"), dark: cover("impostor-dark") },
  "mafia-night": { light: cover("mafia-dark"), dark: cover("mafia-dark") },
  "mafia-day": { light: cover("mafia-light"), dark: cover("mafia-light") },
  "secret-hitler": {
    light: cover("secret-hitler-light"),
    dark: cover("secret-hitler-dark"),
  },
  alibi: { light: cover("alibi-light"), dark: cover("alibi-dark") },
  "liar-dice": { light: cover("liar-dice-light"), dark: cover("liar-dice-dark") },
  spectrum: { light: cover("spectrum-light"), dark: cover("spectrum-dark") },
} as const;
export type ArtKind = keyof typeof playArt;
